module.exports = __webpack_public_path__ + "static/media/logo-small.9bef81b1.svg";